export default __webpack_public_path__ + "static/media/fastStats-logo@2x.f594f93f.png";